/** Version of the envelope and record formats. Bump only with a migration plan. */
export const PROTOCOL_VERSION = 1;

/** Days the relay holds an undelivered encrypted package before deleting it. */
export const RELAY_TTL_DAYS = 30;

/**
 * Days the server keeps audit log entries. The DPDP Rules 2025 ask for at least
 * one year and the CERT-In Directions for 180 days, so 400 leaves a margin.
 */
export const AUDIT_LOG_RETENTION_DAYS = 400;

/**
 * ABDM health information types. Consent scopes and FHIR document profiles use
 * these names so records can move through ABDM without translation.
 */
export const HI_TYPES = [
  'Prescription',
  'DiagnosticReport',
  'OPConsultation',
  'DischargeSummary',
  'ImmunizationRecord',
  'HealthDocumentRecord',
  'WellnessRecord',
  'Invoice',
] as const;
export type HiType = (typeof HI_TYPES)[number];

export function isHiType(value: unknown): value is HiType {
  return typeof value === 'string' && (HI_TYPES as readonly string[]).includes(value);
}
